import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import NotFoundPage from '../pages/403Page';
import TransactionDetail from '../pages/accounting/TransactionDetail';
import MainPage from '../pages/reception/MainPage';
import PosPage from '../pages/reception/PosPage';
import LoginPage from '../pages/LoginPage';
import AccountingDashboard from '../pages/accounting/DashboardPage';
import ClosureDetailPage from '../pages/accounting/ClosureDetailPage';
import ClosurePrint from '../pages/accounting/ClosureDetailPage/print';
import StatsPage from "../pages/accounting/StatsPage";

const roleRoutes = {
  login: [
    {
      path: '/',
      exact: true,
      component: LoginPage,
    },
  ],
  receptionist: [
    {
      path: '/',
      exact: true,
      component: MainPage,
      private: true,
    },
    {
      path: '/pos',
      component: PosPage,
      private: true,
    },
  ],
  accountant: [
    {
      path: '/',
      exact: true,
      component: AccountingDashboard,
      private: true,
    },
    {
      path: '/closure/:id',
      exact: true,
      component: ClosureDetailPage,
    },
    {
      path: '/closure/:id/print',
      exact: true,
      component: ClosurePrint,
    },
    {
      path: '/transaction/:id',
      exact: true,
      component: TransactionDetail,
    },
    {
      path: '/stats/',
      exact: true,
      component: StatsPage,
    },
  ],
};

const MainRouter = () => {
  const [routes, setRoutes] = useState([]);
  const loginData = useSelector((state) => state.login.data);

  useEffect(() => {
    let routeItems = [];
    if (loginData) {
      switch (loginData.role) {
        case 'accountant':
          routeItems = [...routeItems, ...roleRoutes.accountant];
          break;

        case 'receptionist':
        default:
          routeItems = [...routeItems, ...roleRoutes.receptionist];
          break;
      }
    } else {
      routeItems = [...roleRoutes.login];
    }

    setRoutes(routeItems);
  }, [loginData]);

  if (loginData) {
    return (
      <>
        {routes?.length > 0 && (
          <Switch>
            {routes.map((route, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  render={(props) => {
                    if (route.private && !loginData) {
                      return <Redirect to={'/'} />;
                    }
                    return <route.component {...props} />;
                  }}
                />
              );
            })}
            <Route component={NotFoundPage} status={404} />
          </Switch>
        )}
      </>
    );
  } else {
    return (
      <Switch>
        {routes?.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={(props) => {
                if (route.private && !loginData) {
                  return <Redirect to={'/'} />;
                }
                return <route.component {...props} />;
              }}
            />
          );
        })}
        <Route render={() => <Redirect to="/" />} />
      </Switch>
    );
  }
};

export default MainRouter;
